//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapActions, mapGetters } from 'vuex'
import { axiosGet } from '../../../axios/axios.js'
import TableComponent from '../../../components/TableComponent/TableComponent.vue'

const ACTUALITY_IMAGE_VIEWER_OPTIONS = {
  className: 'viewer-actuality-report',
  container: 'div#report-body',
  resizeImageToViewport: true
}

export default {
  components: {
    TableComponent: TableComponent
  },
  props: {
    technologicalResultsActuality: {
      default () {
        return []
      },
      type: Array
    },
    reportId: {
      type: Number,
      default: 0
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    reportTitle: {
      type: String,
      default () {
        return ''
      }
    },
    contractor: {
      type: Boolean,
      default: false
    },
    showMobileView: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      notificationsPR1: [],
      notificationsPR4: [],
      resultsActuality: [],
      selectedItems: [],
      folded: false,
      actualityViewerOptions: ACTUALITY_IMAGE_VIEWER_OPTIONS,
      columnsResultActuality: [
        {
          name: 'name',
          label: 'Название',
          align: 'left',
          field: 'name',
          classes: 'class-bordered',
          sortable: true
        },
        {
          name: 'value',
          label: 'Значение в отчёте',
          align: 'left',
          field: 'value',
          classes: 'class-bordered',
          format: this.formatValue,
          sortable: true
        },
        {
          name: 'dictValue',
          label: 'Значение в карточке объекта обслуживания',
          align: 'left',
          field: 'dictValue',
          classes: 'class-bordered',
          sortable: true
        }
      ],
      columnsReport: [
        {
          name: 'name',
          label: 'Отчёт',
          align: 'left',
          field: 'name',
          classes: 'class-bordered',
          sortable: true
        }
      ],
      headClientHeight: 0
    }
  },
  computed: {
    ...mapGetters({
      fullScreen: 'getActualityWindowFullScreen'
    }),
    docsHeaderFixed: function () {
      return this.$store.getters.getUserSetting('ui.common.docsHeaderFixed', true)
    },
    fullScreenMode: function () {
      return this.showMobileView || this.fullScreen
    }
  },
  created: function () {
    this.prepareTechnologicalResultsActuality()
  },
  mounted: function () {
    // document.addEventListener('keydown', this.closeOnEsc)
    const fullScreen = localStorage.getItem('actualityWindowFullScreen') === 'true'
    if (fullScreen !== this.fullScreen) {
      this.toggleFullcreen()
    }
    this.updateImageViewerOptions()
    window.addEventListener('resize', this.resizeHandler)
    this.resizeHandler()
  },
  updated: function () {
    this.updateImageViewerOptions()
  },
  beforeDestroy: function () {
    // document.removeEventListener('keydown', this.closeOnEsc)
    window.removeEventListener('resize', this.resizeHandler)
    this.setImageViewerOptions({})
  },
  methods: {
    ...mapActions({
      setImageViewerOptions: 'setImageViewerOptions',
      setActualityWindowFullScreen: 'setActualityWindowFullScreen'
    }),
    resizeHandler: function (e) {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      this.headClientHeight = +(this.$refs.headForm ? this.$refs.headForm.$el.clientHeight : 81) + 10
    },
    updateImageViewerOptions: function () {
      if (!this.folded && !this.fullScreen) {
        this.setImageViewerOptions(ACTUALITY_IMAGE_VIEWER_OPTIONS)
      } else {
        this.setImageViewerOptions({})
      }
    },
    prepareTechnologicalResultsActuality: function () {
      for (let i = 0; i < this.technologicalResultsActuality.length; i++) {
        const item = this.technologicalResultsActuality[i]
        if (!item.value || item.value === 'null, null' || item.value === item.dictValue) {
          this.$set(item, '_disabled', true)
        } else {
          this.$set(item, '_disabled', false)
        }
        if (item.type === 'actual' || item.type === 'actualityTimeExceedsPR4' || item.type === 'actualityTimeExceedsPR1') {
          this.resultsActuality.push(item)
        } else if (item.type === 'anotherReportTimeExceedsPR4') {
          this.notificationsPR4.push(item)
        } else if (item.type === 'anotherReportTimeExceedsPR1') {
          this.notificationsPR1.push(item)
        }
      }
    },
    onSelectedItemsIds: function (itemsIds) {
      this.selectedItems = itemsIds
    },
    close: function () {
      this.$emit('close')
    },
    toggleFullcreen: function () {
      localStorage.setItem('actualityWindowFullScreen', !this.fullScreen)
      this.setActualityWindowFullScreen(!this.fullScreen)
    },
    // closeOnEsc: function (event) {
    //   if (event.code === 'Escape') {
    //     this.close()
    //   }
    // },
    formatValue: function (value) {
      if (typeof value === 'boolean') {
        if (value) {
          return 'Да'
        } else {
          return 'Нет'
        }
      } else {
        if (value && value !== 'null, null') {
          return value
        } else if (value === '') {
          return value
        } else {
          return 'Нет значения'
        }
      }
    },
    onActualize: function () {
      const props = this.selectedItems
      axiosGet({
        url: '/service/delta/report/applyDictionaryChanges/' + this.reportId + '?props=' + props + '&contractor=' + this.contractor,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешная актуализация параметров',
            progress: true,
            timeout: 3000
          })

          this.$emit('update')
        },
        onFailure: 'Ошибка актуализации параметров',
        msgTarget: this
      })
    }
  }
}

